/* GoodyBro theme — global JS. Vanilla, no dependencies. Loaded with defer. */
(function () {
  'use strict';

  const GB = (window.GB = window.GB || {});
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Utilities ---------- */
  GB.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || GB.moneyFormat || '{{amount}}';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (n, precision, thousands = ',', decimal = '.') => {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      const parts = n.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    };
    const match = format.match(placeholder);
    if (!match) return format;
    let value;
    switch (match[1]) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  };

  GB.toast = function (msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 2600);
  };

  GB.lockScroll = function (on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
  };

  /* ---------- Drawers ---------- */
  GB.openDrawer = function (id) {
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    GB.lockScroll(true);
    const focusable = d.querySelector('input, button, a');
    setTimeout(() => focusable && focusable.focus(), 50);
    d._opener = document.activeElement;
  };
  GB.closeDrawer = function (d) {
    if (typeof d === 'string') d = document.getElementById(d);
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    GB.lockScroll(false);
    if (d._opener && d._opener.focus) d._opener.focus();
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (opener.dataset.drawerOpen === 'CartDrawer' && GB.cartType !== 'drawer') return;
      e.preventDefault();
      GB.openDrawer(opener.dataset.drawerOpen);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      GB.closeDrawer(closer.closest('.gb-drawer'));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.gb-drawer.is-open').forEach((d) => GB.closeDrawer(d));
    $$('.gb-quick.is-open').forEach((q) => q.classList.remove('is-open'));
  });

  /* ---------- Cart ---------- */
  GB.cartSections = function () {
    const ids = ['cart-drawer'];
    $$('[data-cart-section]').forEach((el) => ids.push(el.dataset.cartSection));
    return Array.from(new Set(ids));
  };

  // Update only the parts of the cart that changed. Unchanged lines keep their
  // images and the drawer keeps its scroll position, so nothing flashes.
  const lineByKey = (key, root = document) => $$('[data-key]', root).find((li) => li.dataset.key === String(key));
  function patchLine(cur, fresh) {
    const sels = ['[data-line-img]', '[data-line-body]'];
    for (const sel of sels) {
      const a = $(sel, cur);
      const b = $(sel, fresh);
      if (!a || !b) { cur.innerHTML = fresh.innerHTML; break; }
      if (a.outerHTML !== b.outerHTML) a.replaceWith(b);
    }
    cur.className = fresh.className;
  }
  function patchLines(cur, fresh) {
    const freshLines = $$('[data-key]', fresh);
    const keep = new Set(freshLines.map((li) => li.dataset.key));
    $$('[data-key]', cur).forEach((li) => { if (!keep.has(li.dataset.key)) li.remove(); });
    let ref = cur.firstElementChild;
    freshLines.forEach((fl) => {
      let cl = lineByKey(fl.dataset.key, cur);
      if (cl) patchLine(cl, fl); else cl = fl;
      if (cl !== ref) cur.insertBefore(cl, ref);
      ref = cl.nextElementSibling;
    });
  }
  function patchCart(cur, fresh) {
    const a = $$('[data-cart-part]', cur);
    const b = $$('[data-cart-part]', fresh);
    const same = a.length === b.length && a.every((p, i) => p.dataset.cartPart === b[i].dataset.cartPart);
    if (!same) { cur.innerHTML = fresh.innerHTML; return; }
    a.forEach((p, i) => {
      if (p.dataset.cartPart === 'lines') patchLines(p, b[i]);
      else if (p.innerHTML !== b[i].innerHTML) p.innerHTML = b[i].innerHTML;
    });
  }
  function rememberFocus() {
    const el = document.activeElement;
    const li = el && el.closest && el.closest('[data-key]');
    if (!li) return null;
    const attr = ['data-line-qty', 'data-line-input', 'data-line-remove'].find((n) => el.hasAttribute(n));
    return attr ? { key: li.dataset.key, attr, val: el.getAttribute(attr) } : null;
  }
  function restoreFocus(f) {
    if (!f) return;
    const li = lineByKey(f.key);
    const el = li && $('[' + f.attr + (f.val ? '="' + f.val + '"' : '') + ']', li);
    if (el) { if (document.activeElement !== el) el.focus({ preventScroll: true }); return; }
    const drawer = document.getElementById('CartDrawer');
    if (drawer && drawer.classList.contains('is-open')) { const c = $('.gb-icon-btn', drawer); if (c) c.focus({ preventScroll: true }); }
  }

  // Returns true when the drawer (if the page has one) was updated.
  GB.renderCartSections = function (sections) {
    if (!sections) return false;
    const focus = rememberFocus();
    let drawerDone = false;
    Object.keys(sections).forEach((id) => {
      const html = sections[id];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        const fresh = doc.querySelector('[data-cart-drawer-inner]');
        const cur = document.querySelector('[data-cart-drawer-inner]');
        if (fresh && cur) { patchCart(cur, fresh); drawerDone = true; }
        const countEl = doc.querySelector('[data-cart-count-value]');
        if (countEl) GB.updateCount(parseInt(countEl.dataset.cartCountValue, 10) || 0);
      } else {
        const fresh = doc.querySelector('[data-cart-section="' + id + '"]');
        const cur = document.querySelector('[data-cart-section="' + id + '"]');
        if (fresh && cur) patchCart(cur, fresh);
      }
    });
    restoreFocus(focus);
    return drawerDone || !document.querySelector('[data-cart-drawer-inner]');
  };

  GB.updateCount = function (count) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; });
    $$('[data-cart-label]').forEach((el) => el.setAttribute('aria-label', el.dataset.cartLabel.replace('[count]', count)));
  };

  GB.syncCount = function () {
    return fetch(GB.routes.cart + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then((r) => r.json())
      .then((c) => GB.updateCount(c.item_count))
      .catch(() => {});
  };

  GB.refreshCart = function () {
    const ids = GB.cartSections().join(',');
    return fetch(GB.routes.root.replace(/\/$/, '') + '/?sections=' + ids, { cache: 'no-store' })
      .then((r) => r.json())
      .then((s) => { if (!GB.renderCartSections(s)) GB.syncCount(); })
      .catch(() => GB.syncCount());
  };

  GB.addToCart = function (items, opts = {}) {
    const body = { items: Array.isArray(items) ? items : [items], sections: GB.cartSections().join(','), sections_url: window.location.pathname };
    return fetch(GB.routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || data.status) throw new Error(data.description || data.message || GB.strings.error);
        document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
        if (opts.checkout) {
          window.location.href = '/checkout';
          return data;
        }
        if (GB.cartType === 'page') {
          window.location.href = GB.routes.cart;
          return data;
        }
        if (!GB.renderCartSections(data.sections)) GB.refreshCart();
        const drawer = document.getElementById('CartDrawer');
        if (GB.cartType === 'drawer' && drawer) {
          if (!drawer.classList.contains('is-open')) GB.openDrawer('CartDrawer');
        } else {
          GB.toast(GB.strings.added);
        }
        return data;
      });
  };

  // Requests run one at a time so quick clicks can't arrive out of order.
  let cartQueue = Promise.resolve();
  GB.changeLine = function (key, quantity) {
    const mark = (on) => { const li = lineByKey(key); if (li) li.classList.toggle('is-updating', on); };
    mark(true);
    const run = () => fetch(GB.routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(key), quantity, sections: GB.cartSections().join(','), sections_url: window.location.pathname })
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || data.status) {
          GB.toast(data.description || data.message || GB.strings.error);
          return GB.refreshCart();
        }
        if (!GB.renderCartSections(data.sections)) GB.refreshCart();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      })
      .catch(() => { GB.toast(GB.strings.error); return GB.refreshCart(); })
      .finally(() => mark(false));
    cartQueue = cartQueue.then(run, run);
    return cartQueue;
  };

  // Cart line quantity controls (drawer + page). Delegated so re-rendered markup works.
  // +/- clicks are grouped: the cart updates once the shopper stops clicking.
  const qtyTimers = {};
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line-qty]');
    if (btn) {
      e.preventDefault();
      const li = btn.closest('[data-key]');
      if (!li) return;
      const key = li.dataset.key;
      const input = $('[data-line-input]', li);
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.lineQty, 10));
      input.value = next;
      if (next === 0) li.classList.add('is-updating');
      clearTimeout(qtyTimers[key]);
      qtyTimers[key] = setTimeout(() => {
        const cur = lineByKey(key);
        const field = cur && $('[data-line-input]', cur);
        GB.changeLine(key, field ? Math.max(0, parseInt(field.value, 10) || 0) : next);
      }, 350);
      return;
    }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) {
      e.preventDefault();
      const li = rm.closest('[data-key]');
      if (li) GB.changeLine(li.dataset.key, 0);
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    const li = input && input.closest('[data-key]');
    if (li) GB.changeLine(li.dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
    const note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(GB.routes.cart_update + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }
  });

  // Back/forward navigation can show a cached page with an old cart. Resync it.
  window.addEventListener('pageshow', (e) => { if (e.persisted) GB.refreshCart(); });
  // Apps can ask the theme to redraw the cart after changing it.
  document.addEventListener('cart:refresh', () => GB.refreshCart());

  // Ajax product forms. Any form with data-ajax-cart adds to cart without page reload.
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const submitter = e.submitter || form.querySelector('[type="submit"]');
    const buyNow = submitter && submitter.name === 'buy_now';
    const fd = new FormData(form);
    const id = fd.get('id');
    if (!id) return;
    const item = { id: Number(id), quantity: Number(fd.get('quantity') || 1) };
    const props = {};
    for (const [k, v] of fd.entries()) {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m && v !== '') props[m[1]] = v;
    }
    if (Object.keys(props).length) item.properties = props;
    if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));

    const buttons = $$('[type="submit"]', form).concat(form.closest('gb-product') ? $$('[data-sticky-atc] [data-add-button]') : []);
    buttons.forEach((b) => b.classList.add('is-loading'));
    const err = form.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    GB.addToCart(item, { checkout: buyNow })
      .catch((ex) => {
        if (err) { err.textContent = ex.message; err.hidden = false; } else GB.toast(ex.message);
      })
      .finally(() => buttons.forEach((b) => b.classList.remove('is-loading')));
  });

  /* ---------- Quick add (cards, videos) ---------- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-quick-toggle]');
    if (toggle) {
      e.preventDefault();
      const q = toggle.closest('.gb-quick, .gb-card');
      const wrap = q.classList.contains('gb-quick') ? q : q.querySelector('.gb-quick');
      $$('.gb-quick.is-open').forEach((o) => o !== wrap && o.classList.remove('is-open'));
      wrap.classList.toggle('is-open');
      return;
    }
    const close = e.target.closest('[data-quick-close]');
    if (close) {
      e.preventDefault();
      close.closest('.gb-quick').classList.remove('is-open');
      return;
    }
    const add = e.target.closest('[data-quick-add]');
    if (add) {
      e.preventDefault();
      add.classList.add('is-loading');
      add.disabled = true;
      GB.addToCart({ id: Number(add.dataset.quickAdd), quantity: 1 })
        .then(() => { const q = add.closest('.gb-quick'); if (q) q.classList.remove('is-open'); })
        .catch((ex) => GB.toast(ex.message))
        .finally(() => { add.classList.remove('is-loading'); add.disabled = false; });
    }
  });

  /* ---------- Header: overlay + sticky + scrolled state ---------- */
  class GBHeader extends HTMLElement {
    connectedCallback() {
      this.wrap = this.closest('.gb-header-wrap') || this;
      if (!this.wrap.classList.contains('is-overlay') && !this.wrap.classList.contains('is-sticky')) return;
      const threshold = 80;
      const onScroll = () => this.wrap.classList.toggle('is-scrolled', window.scrollY > threshold);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }
  customElements.define('gb-header', GBHeader);

  /* ---------- Predictive search ---------- */
  class GBSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      if (!this.input || !this.results) return;
      this.input.addEventListener('input', () => {
        clearTimeout(this._t);
        this._t = setTimeout(() => this.search(this.input.value.trim()), 250);
      });
    }
    search(q) {
      if (!q) { this.results.innerHTML = ''; return; }
      const url = GB.routes.predictive_search + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search';
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-predictive-inner]');
          this.results.innerHTML = fresh ? fresh.innerHTML : '';
        })
        .catch(() => {});
    }
  }
  customElements.define('gb-search', GBSearch);

  /* ---------- Slideshow (hero) ---------- */
  class GBSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = $$('[data-slide]', this);
      this.counter = this.querySelector('[data-counter]');
      this.dots = $$('[data-dot]', this);
      this.index = 0;
      if (!this.track || this.slides.length < 2) return;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this._s);
        this._s = setTimeout(() => {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (i !== this.index) this.setIndex(i);
        }, 60);
      }, { passive: true });
      const speed = parseInt(this.dataset.autoplay, 10);
      if (speed > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const start = () => { this.stop(); this._a = setInterval(() => this.go(this.index + 1), speed * 1000); };
        this.stop = () => clearInterval(this._a);
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', start);
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('touchstart', () => this.stop(), { passive: true });
        start();
      }
      // Theme editor: jump to selected block
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.findIndex((s) => s.contains(e.target));
        if (i > -1) { this.stop && this.stop(); this.go(i); }
      });
    }
    stop() {}
    go(i) {
      const n = this.slides.length;
      i = (i + n) % n;
      this.track.scrollTo({ left: this.track.clientWidth * i, behavior: 'smooth' });
      this.setIndex(i);
    }
    setIndex(i) {
      this.index = i;
      const n = this.slides.length;
      if (this.counter) this.counter.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
      this.dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
      this.slides.forEach((s, k) => s.setAttribute('aria-hidden', k === i ? 'false' : 'true'));
    }
  }
  customElements.define('gb-slideshow', GBSlideshow);

  /* ---------- Tabs ---------- */
  class GBTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = $$('[role="tab"]', this);
      this.panels = $$('[role="tabpanel"]', this);
      this.tabs.forEach((t, i) => {
        t.addEventListener('click', () => this.select(i));
        t.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { this.select((i + 1) % this.tabs.length, true); }
          if (e.key === 'ArrowLeft') { this.select((i - 1 + this.tabs.length) % this.tabs.length, true); }
        });
      });
      const viewAll = this.querySelector('[data-view-all]');
      this.viewAll = viewAll;
    }
    select(i, focus) {
      this.tabs.forEach((t, k) => { t.setAttribute('aria-selected', k === i); t.tabIndex = k === i ? 0 : -1; });
      this.panels.forEach((p, k) => { p.hidden = k !== i; });
      if (focus) this.tabs[i].focus();
      if (this.viewAll && this.tabs[i].dataset.url) this.viewAll.href = this.tabs[i].dataset.url;
    }
  }
  customElements.define('gb-tabs', GBTabs);

  /* ---------- Countdown ---------- */
  class GBCountdown extends HTMLElement {
    connectedCallback() {
      let end;
      if (this.dataset.mode === 'evergreen') {
        const hours = parseFloat(this.dataset.hours) || 24;
        const key = 'gb-cd-' + (this.dataset.key || 'x');
        let stored = null;
        try { stored = parseInt(localStorage.getItem(key), 10); } catch (e) {}
        if (!stored || stored < Date.now()) {
          stored = Date.now() + hours * 3600e3;
          try { localStorage.setItem(key, stored); } catch (e) {}
        }
        end = stored;
      } else {
        end = Date.parse(this.dataset.end);
      }
      if (!end || isNaN(end)) { this.classList.add('is-ended'); return; }
      this.end = end;
      this.d = this.querySelector('[data-d]');
      this.h = this.querySelector('[data-h]');
      this.m = this.querySelector('[data-m]');
      this.s = this.querySelector('[data-s]');
      this.tick();
      this._i = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this._i); }
    tick() {
      const left = Math.max(0, this.end - Date.now());
      if (left <= 0) {
        clearInterval(this._i);
        if (this.dataset.hideOnEnd === 'true') this.classList.add('is-ended');
      }
      const s = Math.floor(left / 1000);
      const pad = (n) => String(n).padStart(2, '0');
      if (this.d) this.d.textContent = pad(Math.floor(s / 86400));
      if (this.h) this.h.textContent = pad(Math.floor((s % 86400) / 3600));
      if (this.m) this.m.textContent = pad(Math.floor((s % 3600) / 60));
      if (this.s) this.s.textContent = pad(s % 60);
    }
  }
  customElements.define('gb-countdown', GBCountdown);

  /* ---------- Shoppable video ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-video-toggle]');
    if (!btn) return;
    const wrap = btn.closest('.gb-video, .gb-video-section');
    const video = wrap.querySelector('video');
    if (!video) return;
    if (video.paused) {
      $$('.gb-video.is-playing video').forEach((v) => { if (v !== video) { v.pause(); v.closest('.gb-video').classList.remove('is-playing'); } });
      video.muted = false;
      video.play();
      wrap.classList.add('is-playing');
    } else {
      video.pause();
      wrap.classList.remove('is-playing');
    }
  });

  /* ---------- Lazy autoplay muted videos when visible ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        const v = en.target;
        if (en.isIntersecting) { v.play().catch(() => {}); } else if (!v.closest('.is-playing')) { v.pause(); }
      });
    }, { threshold: 0.4 });
    const watch = () => $$('[data-autoplay="true"] video').forEach((v) => { if (!v._w) { v._w = 1; io.observe(v); } });
    watch();
    document.addEventListener('shopify:section:load', watch);
  }

  /* ---------- Mobile sticky CTA bar (home) ---------- */
  class GBMobileBar extends HTMLElement {
    connectedCallback() {
      document.body.classList.add('has-mobile-bar');
      const bar = this.querySelector('.gb-mobile-bar');
      const offset = parseInt(this.dataset.offset, 10) || 400;
      const onScroll = () => bar.classList.toggle('is-visible', window.scrollY > offset);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    disconnectedCallback() { document.body.classList.remove('has-mobile-bar'); }
  }
  customElements.define('gb-mobile-bar', GBMobileBar);

  /* ---------- Quantity input (product) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    e.preventDefault();
    const input = b.closest('.gb-qty').querySelector('input');
    const min = parseInt(input.min, 10) || 1;
    const max = parseInt(input.max, 10) || 999;
    input.value = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product: gallery ---------- */
  class GBGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = $$('[data-media-id]', this.track);
      this.thumbs = $$('[data-thumb]', this);
      this.count = this.querySelector('[data-count]');
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      if (this.track) {
        this.track.addEventListener('scroll', () => {
          clearTimeout(this._s);
          this._s = setTimeout(() => this.sync(Math.round(this.track.scrollLeft / this.track.clientWidth)), 60);
        }, { passive: true });
      }
    }
    go(i, instant) {
      const s = this.slides[i];
      if (!s) return;
      if (window.matchMedia('(min-width: 990px)').matches && this.classList.contains('gb-gallery--grid')) {
        s.scrollIntoView({ behavior: instant ? 'auto' : 'smooth', block: 'center' });
      } else {
        this.track.scrollTo({ left: this.track.clientWidth * i, behavior: instant ? 'auto' : 'smooth' });
      }
      this.sync(i);
    }
    goToMedia(id) {
      const i = this.slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (i > -1) this.go(i);
    }
    sync(i) {
      this.thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
      if (this.count) this.count.textContent = (i + 1) + ' / ' + this.slides.length;
    }
  }
  customElements.define('gb-gallery', GBGallery);

  /* ---------- Product: variant picker ---------- */
  class GBProduct extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-product-json]');
      if (!json) return;
      this.data = JSON.parse(json.textContent);
      this.section = this.dataset.section;
      this.form = this.querySelector('form[data-ajax-cart]');
      this.idInput = this.form && this.form.querySelector('input[name="id"]');
      this.lowStock = parseInt(this.dataset.lowStock, 10) || 5;
      this.addEventListener('change', (e) => {
        if (!e.target.closest('[data-option]')) return;
        if (e.isTrusted) this.userPicked = true;
        this.onOptionChange();
      });
      this.current = this.data.variants.find((v) => String(v.id) === String(this.idInput && this.idInput.value)) || this.data.variants[0];
      this.updateAvailability();
      this.updateStock(this.current);
      this.setupSticky();
    }
    selectedOptions() {
      return $$('[data-option]', this).map((group) => {
        const checked = group.querySelector('input:checked');
        if (checked) return checked.value;
        const sel = group.querySelector('select');
        return sel ? sel.value : null;
      });
    }
    onOptionChange() {
      const opts = this.selectedOptions();
      let variant = this.data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      $$('[data-option]', this).forEach((group, i) => {
        const lbl = group.querySelector('[data-option-value]');
        if (lbl) lbl.textContent = opts[i];
      });
      this.current = variant;
      this.updateAvailability();
      if (!variant) { this.setButtons(false, GB.strings.unavailable); return; }
      if (this.idInput) { this.idInput.value = variant.id; this.idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      this.updatePrice(variant);
      this.updateStock(variant);
      this.setButtons(variant.available, variant.available ? null : GB.strings.soldOut);
      if (variant.featured_media) {
        const g = this.querySelector('gb-gallery');
        if (g) g.goToMedia(variant.featured_media.id);
      }
      if (this.dataset.updateUrl !== 'false') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant, product: this.data } }));
    }
    updateAvailability() {
      // Mark option values that cannot form an available variant with the other current selections.
      const opts = this.selectedOptions();
      $$('[data-option]', this).forEach((group, idx) => {
        $$('input', group).forEach((input) => {
          const test = opts.slice();
          test[idx] = input.value;
          const ok = this.data.variants.some((v) => v.available && v.options.every((o, i) => o === test[i]));
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    updatePrice(v) {
      const fmt = (c) => GB.formatMoney(c);
      $$('[data-price]').forEach((el) => { el.textContent = fmt(v.price); });
      const hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      const save = hasCompare ? v.compare_at_price - v.price : 0;
      const pct = hasCompare ? Math.round((save / v.compare_at_price) * 100) : 0;
      $$('[data-compare]').forEach((el) => { el.textContent = hasCompare ? fmt(v.compare_at_price) : ''; el.hidden = !hasCompare; });
      $$('[data-save-wrap]').forEach((el) => { el.hidden = !hasCompare; });
      $$('[data-save]').forEach((el) => { el.textContent = fmt(save); });
      $$('[data-save-pct]').forEach((el) => { el.textContent = pct; });
    }
    updateStock(v) {
      const box = this.querySelector('[data-stock]');
      if (!box || !v) return;
      const qty = this.data.inventory ? this.data.inventory[v.id] : null;
      const text = box.querySelector('[data-stock-text]');
      const s = box.dataset;
      let msg = s.inStock, color = 'var(--c-success)', width = '100%';
      const sizeName = v.options[parseInt(s.sizeIndex, 10)] || v.title;
      if (!v.available) {
        msg = s.soldOut.replace('[size]', sizeName); color = '#6B6B6B'; width = '0%';
      } else if (qty != null && qty > 0 && qty <= this.lowStock) {
        msg = s.lowStock.replace('[count]', qty).replace('[size]', sizeName); color = 'var(--c-accent)'; width = Math.max(8, qty * 8) + '%';
      } else if (qty != null && qty > 0) {
        width = Math.min(100, qty * 8) + '%';
      }
      box.style.setProperty('--stock-c', color);
      box.style.setProperty('--stock-w', width);
      if (text) text.textContent = msg;
      $$('[data-sticky-variant]').forEach((el) => { el.textContent = v.title; });
      const img = v.img && $('[data-sticky-img] img');
      if (img && img.dataset.src !== v.img) { img.removeAttribute('srcset'); img.src = v.img; img.dataset.src = v.img; }
    }
    setButtons(enabled, label) {
      $$('[data-add-button]', this).concat($$('[data-sticky-atc] [data-add-button]')).forEach((b) => {
        b.disabled = !enabled;
        const t = b.querySelector('[data-label]');
        if (t) t.textContent = label || b.dataset.defaultLabel;
      });
    }
    setupSticky() {
      const bar = document.querySelector('[data-sticky-atc]');
      const anchor = this.querySelector('[data-buy-anchor]');
      if (!bar || !anchor || !('IntersectionObserver' in window)) return;
      // Keep the footer clear of the bar while it is showing.
      const setPad = (on) => {
        document.body.style.setProperty('--sticky-h', bar.offsetHeight + 'px');
        document.body.classList.toggle('gb-has-sticky', on);
      };
      const io = new IntersectionObserver(([en]) => {
        const passed = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', passed);
        setPad(passed);
      });
      io.observe(anchor);
      window.addEventListener('resize', () => { if (bar.classList.contains('is-visible')) setPad(true); });
      bar.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-sticky-submit]');
        if (!btn || !this.form || btn.disabled) return;
        e.preventDefault();
        const action = btn.dataset.stickySubmit;
        const qty = Number((this.form.querySelector('[name="quantity"]') || {}).value || 1);
        // Products with sizes/options: let the shopper confirm the size in the popup first.
        if (this.data.variants.filter((v) => v.available).length > 1 && this.data.url && window.GBQuickAdd) {
          window.GBQuickAdd.open(this.data.url, btn, {
            checkout: action === 'buy_now',
            label: btn.dataset.defaultLabel,
            quantity: qty,
            variantId: this.userPicked && this.idInput ? this.idInput.value : null
          });
          return;
        }
        const native = this.form.querySelector('[name="' + action + '"]');
        if (native) {
          if (this.form.requestSubmit) this.form.requestSubmit(native); else native.click();
          return;
        }
        // The product form has no button for this action (e.g. buy now is turned off there).
        const id = this.idInput && Number(this.idInput.value);
        if (!id) return;
        btn.classList.add('is-loading');
        GB.addToCart({ id, quantity: qty }, { checkout: action === 'buy_now' })
          .catch((ex) => GB.toast(ex.message))
          .finally(() => btn.classList.remove('is-loading'));
      });
    }
  }
  customElements.define('gb-product', GBProduct);

  /* ---------- Delivery timeline ---------- */
  // Dates are always worked out in Bangladesh time (UTC+6), whatever the shopper's device time zone.
  class GBDelivery extends HTMLElement {
    connectedCallback() {
      this.btns = $$('[data-zone]', this);
      if (!this.btns.length) return;
      const names = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      const off = (this.dataset.offDays || '').toLowerCase();
      this.offDays = names.map((n, i) => (off.indexOf(n) > -1 ? i : -1)).filter((i) => i > -1);
      if (this.offDays.length > 6) this.offDays = [];
      this.holidays = new Set();
      (this.dataset.holidays || '').split(/\n|,/).forEach((line) => {
        const m = line.match(/\d{4}-\d{2}-\d{2}/g);
        if (!m) return;
        const d = this.parse(m[0]);
        const end = this.parse(m[1] || m[0]);
        for (let i = 0; d <= end && i < 60; i++) { this.holidays.add(this.key(d)); d.setDate(d.getDate() + 1); }
      });
      let saved = null;
      try { saved = localStorage.getItem('gb-zone'); } catch (e) {}
      this.zone = Math.max(0, this.btns.findIndex((b) => b.textContent.trim() === saved));
      this.btns.forEach((b, i) => b.addEventListener('click', () => {
        this.zone = i;
        try { localStorage.setItem('gb-zone', b.textContent.trim()); } catch (e) {}
        this.render();
      }));
      this.render();
      this._i = setInterval(() => this.render(), 30000);
    }
    disconnectedCallback() { clearInterval(this._i); }
    parse(s) { const p = s.split('-').map(Number); return new Date(p[0], p[1] - 1, p[2]); }
    key(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
    // A Date whose local fields read as the current time in Dhaka.
    now() { const n = new Date(); return new Date(n.getTime() + (n.getTimezoneOffset() + 360) * 60000); }
    isOff(d) { return this.offDays.indexOf(d.getDay()) > -1 || this.holidays.has(this.key(d)); }
    nextWorking(d) {
      const x = new Date(d);
      let guard = 0;
      do { x.setDate(x.getDate() + 1); } while (this.isOff(x) && ++guard < 90);
      return x;
    }
    addWorking(d, n) { let x = new Date(d); for (let i = 0; i < n; i++) x = this.nextWorking(x); return x; }
    render() {
      const ds = this.dataset;
      const b = this.btns[this.zone] || this.btns[0];
      this.btns.forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      const min = parseInt(b.dataset.min, 10) || 1;
      const max = Math.max(min, parseInt(b.dataset.max, 10) || min);
      const cutoff = parseInt(ds.cutoff, 10);
      const now = this.now();
      const closed = this.isOff(now);
      const late = now.getHours() >= cutoff;
      const ship = closed || late ? this.nextWorking(now) : new Date(now);
      const first = this.addWorking(ship, min);
      const last = this.addWorking(ship, max);
      const loc = (document.documentElement.lang || 'en').indexOf('bn') === 0 ? 'bn-BD' : 'en-GB';
      const full = { weekday: 'short', day: 'numeric', month: 'short' };
      const fmt = (d, o) => d.toLocaleDateString(loc, o || full);
      const set = (k, v) => { const el = this.querySelector('[data-' + k + ']'); if (el) el.textContent = v; };
      set('date-order', fmt(now));
      set('date-ship', fmt(ship));
      if (max > min) {
        const sameMonth = first.getMonth() === last.getMonth();
        set('date-arrive', fmt(first, sameMonth ? { weekday: 'short', day: 'numeric' } : full) + ' – ' + fmt(last));
      } else {
        set('date-arrive', ds.byLabel + ' ' + fmt(first));
      }
      if (closed) {
        set('cutoff-text', (ds.closedText || ds.afterText || '').replace('[date]', fmt(ship)));
      } else if (late) {
        set('cutoff-text', (ds.afterText || '').replace('[date]', fmt(ship)));
      } else {
        const end = new Date(now); end.setHours(cutoff, 0, 0, 0);
        const mins = Math.max(0, Math.round((end - now) / 60000));
        set('cutoff-text', (ds.beforeText || '').replace('[time]', Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm'));
      }
    }
  }
  customElements.define('gb-delivery', GBDelivery);

  /* ---------- Modal (size guide etc.) ---------- */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-modal-open]');
    if (open) {
      const m = document.getElementById(open.dataset.modalOpen);
      if (m && m.showModal) { e.preventDefault(); m.showModal(); }
      return;
    }
    const close = e.target.closest('[data-modal-close]');
    if (close) { e.preventDefault(); close.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('gb-modal')) e.target.close();
  });

  /* ---------- Wishlist heart (local only, apps can replace) ---------- */
  document.addEventListener('click', (e) => {
    const w = e.target.closest('[data-wish]');
    if (!w) return;
    e.preventDefault();
    let list = [];
    try { list = JSON.parse(localStorage.getItem('gb-wish') || '[]'); } catch (x) {}
    const id = w.dataset.wish;
    const i = list.indexOf(id);
    if (i > -1) list.splice(i, 1); else list.push(id);
    try { localStorage.setItem('gb-wish', JSON.stringify(list)); } catch (x) {}
    w.classList.toggle('is-active', i === -1);
    w.setAttribute('aria-pressed', i === -1);
  });

  /* ---------- Share ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-share]');
    if (!b) return;
    e.preventDefault();
    const url = b.dataset.share;
    if (navigator.share) navigator.share({ url, title: document.title }).catch(() => {});
    else if (navigator.clipboard) navigator.clipboard.writeText(url).then(() => GB.toast(b.dataset.copied || 'Link copied'));
  });

  /* ---------- Collection filters: auto submit ---------- */
  document.addEventListener('change', (e) => {
    const f = e.target.closest('form[data-filter-form]');
    if (!f || e.target.type === 'number') return;
    f.submit();
  });
  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-sort-select]');
    if (!s) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- WhatsApp opt in forms ---------- */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-wa-optin]');
    if (!f) return;
    const phone = f.querySelector('[data-wa-phone]').value.trim();
    const t = f.querySelector('[data-wa-text]');
    t.value = (t.dataset.template || '').replace('[phone]', phone);
  });

  /* ---------- Fit text (footer wordmark) to its container ---------- */
  const fitText = () => $$('[data-fit-text]').forEach((el) => {
    el.style.fontSize = '';
    const avail = el.clientWidth;
    const need = el.scrollWidth;
    if (need > avail && avail > 0) {
      const size = parseFloat(getComputedStyle(el).fontSize);
      el.style.fontSize = Math.floor(size * (avail / need) * 0.98) + 'px';
    }
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitText); else fitText();
  window.addEventListener('resize', () => { clearTimeout(fitText._t); fitText._t = setTimeout(fitText, 150); });
  document.addEventListener('shopify:section:load', fitText);

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#CartDrawer')) GB.refreshCart();
  });
})();
